import React from 'react';
import classNames from 'classnames';

export default function Title({children, className="justify-center", mb="mb-10"}) {
  return (
    <div className={classNames('text-3xl flex', className, mb)}>{children}</div>
  )
}
